import { DOMUtils } from '../../DOM/DOMUtils';
import { TourConfig } from '../../../types/TourConfig';

export class TourBackdropController {
  constructor(private readonly domUtils: DOMUtils) {}

  show(opacity: number, customStyle: TourConfig['customBackdropStyle']) {
    this.domUtils.showBackdrop(opacity, customStyle);
  }

  hide() {
    this.domUtils.hideBackdrop();
  }
}
